'use client';

import React, { Suspense } from 'react';
import { useInView } from 'react-intersection-observer';

const LazySection = ({ children, fallback = <div>Loading...</div>, threshold = 0.1, delay = 2000 }) => {
	const { ref, inView } = useInView({
		triggerOnce: true,
		threshold,
		delay: delay,
	});

	return (
		<div
			ref={ref}
			className={'lazy-wrapper'}>
			<div className='suspense-wrapper'>
				<Suspense fallback={fallback}>{inView ? children : fallback}</Suspense>
			</div>
		</div>
	);
};

export default LazySection;
